export const apiCreate = (): string => '/commercial/institutions/create/'
export const apiList = (id?: string): string =>
  !id ? '/commercial/institutions/' : `/commercial/institutions/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/institutions/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/institutions/delete/${id}`
